module.exports = __webpack_public_path__ + "img/39.ab7f9ff5.jpg";